<header *ngIf="isLoggedIn">
  <div class="container-header">
    
    <!-- Contenitore sinistro con menu mobile + logo -->
    <div class="container-sx">
      <!--LOGO-->
      <a href="https://workinc.vtserver.eu/" class="logo-link">
        <img src="img/logo_white.png" class="logo-img" alt="Logo" />
      </a>

      <div class="mobile-menu">
        <button mat-icon-button [matMenuTriggerFor]="mobileMenu" [attr.aria-label]="'header.open-navigation-menu' | translate">
          <mat-icon class="menu">menu</mat-icon>
        </button>
        <mat-menu #mobileMenu="matMenu" panelClass="mobile-menu-panel">
          <button mat-menu-item routerLink="/dashboard">
            <mat-icon>home</mat-icon>{{ 'header.dashboard' | translate }}
          </button>
          <button mat-menu-item routerLink="/profile">
            <mat-icon>account_circle</mat-icon>{{ 'header.profile' | translate }}
          </button>
          <button mat-menu-item routerLink="/available-internships">
            <mat-icon>work</mat-icon>{{ 'header.available-internships' | translate }}
          </button>
          <button mat-menu-item routerLink="/internships">
            <mat-icon>school</mat-icon>{{ 'header.internships' | translate }}
          </button>
          <button mat-menu-item routerLink="/inclusion-index">
            <mat-icon>show_chart</mat-icon>{{ 'header.inclusion-index' | translate }}
          </button>
          <button mat-menu-item routerLink="/report-and-results">
            <mat-icon>library_books</mat-icon>{{ 'header.report-analysis' | translate }}
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>Logout
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- MENU desktop + selettore lingua al centro -->
    <div class="container-dx">
      <!-- DESKTOP MENU (visibile solo su desktop) -->
      <div class="voci-menu desktop-menu">
        <ul>
          <li><a routerLink="/dashboard" routerLinkActive="active-link"><mat-icon>home</mat-icon><span class="nav-label">{{ 'header.dashboard' | translate }}</span></a></li>
          <li><a routerLink="/profile" routerLinkActive="active-link"><mat-icon>account_circle</mat-icon><span class="nav-label">{{ 'header.profile' | translate }}</span></a></li>
          <li><a routerLink="/available-internships" routerLinkActive="active-link"><mat-icon>work</mat-icon><span class="nav-label">{{ 'header.available-internships' | translate }}</span></a></li>
          <li><a routerLink="/internships" routerLinkActive="active-link"><mat-icon>school</mat-icon><span class="nav-label">{{ 'header.internships' | translate }}</span></a></li>
          <li><a routerLink="/inclusion-index" routerLinkActive="active-link"><mat-icon>show_chart</mat-icon><span class="nav-label">{{ 'header.inclusion-index' | translate }}</span></a></li>
          <li><a routerLink="/report-and-results" routerLinkActive="active-link"><mat-icon>library_books</mat-icon><span class="nav-label">{{ 'header.report-analysis' | translate }}</span></a></li>
        </ul>
      </div>

      <mat-menu #languageMenu="matMenu" [@.disabled]="true">
        @for (language of languages; track $index) {
          @if (selectedLanguage != language) {
            <button mat-menu-item (click)="changeLanguage(language)" class="language-option">
              <img src="{{language.urlImg}}" class="flag-icon">
              <span>{{ language.labelKey | translate }}</span>
            </button>
          }
        }
      </mat-menu>
    </div>

    <div class="right-actions" [matMenuTriggerFor]="languageMenu">
      <div class="header-actions">
        <div class="icon">
          <p>{{selectedLanguage.coname}}</p>
          <img src="{{selectedLanguage.urlImg}}">
          <ul>
            <li class="language-item">
              <button mat-icon-button class="language-btn">
                <mat-icon>language</mat-icon>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="logout-icon">
        <a class="logout" (click)="logout()"><mat-icon>logout</mat-icon></a>
      </div>
    </div>

    </div>

</header>
